import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title, Subtitle } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { MEDICINE, UPDATE_MEDICINE } from './queries';
import { FIELDS } from './new';

const Medicine = () => {
  const { id } = useParams();
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(MEDICINE, { variables: { id } });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.medicine }));
    }
  }, [data]);

  const [updateMedicine] = useMutation(UPDATE_MEDICINE, {
    onCompleted: () => navigate('/medicines'),
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    updateMedicine({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>{data?.medicine.name}</Title>

      <Subtitle>Client: {data?.medicine.client.name}</Subtitle>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Medicine;
